import {ChangeDetectorRef, Component,
  CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {DcpHeadlineData} from '@app/model/dcp-headline-data';
import {DcpMedia, IMAGE_FORMAT} from '@app/model/dcp-media';
import {JsonService, TypeValuePair} from '@dcp/configurator';
import {CurrentProductService} from '@spartacus/storefront';
import {DcpProductUtilitiesService} from '../../services/dcp-product-utilities.service';
import {NavigationLink} from '../navigation-bar/navigation-link';
import {ProductDetailsNavigationLinkService} from '../navigation-bar/product-details-navigation-link.service';
import {ProductDetailsSectionComponent} from '../product-details-section/product-details-section.component';
import {LimitedTextComponent} from '../../../shared/limited-text/limited-text.component';
import {DcpMediaComponent} from '../../../shared/dcp-media/dcp-media.component';
import {TranslatePipe} from '@spartacus/core';
import {ProductPageDecoratorService} from '@app/product/services/product-page-decorator.service';

interface CustomDcpHeadlineData extends DcpHeadlineData {
  media: CustomDcpMedia[];
}

interface CustomDcpMedia extends DcpMedia {
  right?: boolean;
}

@Component({
  selector: 'dcp-features-and-benefits',
  templateUrl: './features-and-benefits.component.html',
  styleUrls: ['./features-and-benefits.component.scss'],
  imports: [LimitedTextComponent, DcpMediaComponent, TranslatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FeaturesAndBenefitsComponent extends ProductDetailsSectionComponent {
  benefits: CustomDcpHeadlineData[] = [];
  benefitsExtended = false;
  features: CustomDcpHeadlineData[] = [];
  featuresExtended = false;
  benefitSlotLimit = 3;
  featureSlotLimit = 4;
  navLink: NavigationLink = {
    headline: 'productDetails.features',
    id: 'benefits-and-features',
  };

  constructor(
    dcpProductUtilitiesService: DcpProductUtilitiesService,
    protected currentProductService: CurrentProductService,
    protected changeDetection: ChangeDetectorRef,
    protected productDetailsNavigationLinkService: ProductDetailsNavigationLinkService,
    protected productPageDecoratorService: ProductPageDecoratorService,
    private jsonService: JsonService,
  ) {
    super(currentProductService, changeDetection, productDetailsNavigationLinkService, dcpProductUtilitiesService, productPageDecoratorService);
  }

  get hasBenefits(): boolean {
    return this.benefits.length > 0;
  }

  get hasFeatures(): boolean {
    return this.features.length > 0;
  }

  get limitedBenefits(): CustomDcpHeadlineData[] {
    return this.benefitsExtended ? this.benefits : this.benefits.slice(0, this.benefitSlotLimit);
  }

  get limitedFeatures(): CustomDcpHeadlineData[] {
    return this.featuresExtended ? this.features : this.features.slice(0, this.featureSlotLimit);
  }

  get featuresExceedsLimit(): boolean {
    return this.features.length > this.featureSlotLimit;
  }

  get benefitsExceedsLimit(): boolean {
    return this.benefits.length > this.benefitSlotLimit;
  }

  isVisible(): boolean {
    return this.hasBenefits || this.hasFeatures;
  }

  toggleBenefits(): void {
    this.benefitsExtended = !this.benefitsExtended;
  }

  toggleBenefitsWithKeyboard(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.toggleBenefits();
    }
  }

  toggleFeatures(): void {
    this.featuresExtended = !this.featuresExtended;
  }

  toggleFeaturesWithKeyboard(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.toggleFeatures();
    }
  }

  prepareData(): void {
    this.prepareHeadlines();
  }

  isImageFormat(format: string): boolean {
    return format === IMAGE_FORMAT;
  }

  prepareHeadlines(): void {
    this.benefits = [];
    this.features = [];
    if (this.product?.data) {
      const rawHeadlines: TypeValuePair = this.product.data.find((entry) => entry.type === 'headlines');
      try {
        if (rawHeadlines?.value) {
          const parsedHeadlines: CustomDcpHeadlineData[] = this.jsonService.parseSafely(
            rawHeadlines.value,
          ) as CustomDcpHeadlineData[];
          this.benefits = parsedHeadlines.filter((headline) => headline.type === 'benefit');
          this.features = parsedHeadlines.filter((headline) => headline.type === 'feature');
          this.alternateSide();
        }
      } catch (e) {}
    }
  }

  private alternateSide(): void {
    let alternateSide = true;
    for (const headline of this.features) {
      if (headline.media.length) {
        for (const media of headline.media) {
          media.right = alternateSide;
        }
        alternateSide = !alternateSide;
      }
    }
  }
}
